import styled from 'styled-components';
import { lighten } from 'polished';
import { COLOR_RED } from '../../assets/styles/colors';

export const ErrorModalSC = styled.div`
  padding: 60px 0;
`;

export const IconWrap = styled.div`
  margin: 0 auto 20px auto;
  height: 80px;
  width: 80px;
  min-width: 80px;
  border-radius: 40px;
  background: ${lighten('0.3', COLOR_RED)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
`;
